import { render, staticRenderFns } from "./config-system-parameters.vue?vue&type=template&id=1d4af8ae"
import script from "./configSystemParameters.js?vue&type=script&lang=js&external"
export * from "./configSystemParameters.js?vue&type=script&lang=js&external"
import style0 from "./config-system-parameters.vue?vue&type=style&index=0&id=1d4af8ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports